module.exports = __webpack_public_path__ + "static/img/rank_239.ba29ffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_239.png
// module id = M45M
// module chunks = 1